export default "__VITE_ASSET__b02f07ee__"